import { getApiBaseUrl } from "../config/runtimeConfig";

const apiBaseUrl = getApiBaseUrl();

export class ApiError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

export interface Property {
  id: number;
  name: string;
  address?: string | null;
  propertyType?: string | null;
  area?: number | null;
  rentValue?: number | null;
  annualImi?: number | null;
  created: string;
  lastModified: string;
}

export interface PropertyPayload {
  name: string;
  address?: string | null;
  propertyType?: string | null;
  area?: number | null;
  rentValue?: number | null;
  annualImi?: number | null;
}

async function request<T>(
  path: string,
  options?: RequestInit,
): Promise<T> {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    credentials: "include",
  });

  if (!response.ok) {
    const text = await response.text();
    throw new ApiError(
      response.status,
      text || response.statusText,
    );
  }

  return (await response.json()) as T;
}

export function getProperties(): Promise<Property[]> {
  return request<Property[]>("/api/properties");
}

export function getPropertyById(propertyId: number): Promise<Property> {
  return request<Property>(`/api/properties/${propertyId}`);
}

export function createProperty(payload: PropertyPayload): Promise<Property> {
  return request<Property>("/api/properties", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function updateProperty(
  propertyId: number,
  payload: PropertyPayload,
): Promise<Property> {
  return request<Property>(`/api/properties/${propertyId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}
